import {
  AsyncActionState,
  IAsyncAction,
  IAsyncFetchableAction,
  IAsyncErrorAction,
} from '@telstra-connect/standard-actions/async-action'
import {SERVICE_PERFORMANCE_LOAD_SERVICE_TYPES_INT} from './action-types'
import {IServiceTypesResponseInt} from '../state/service-types-int'

export interface ILoadServiceTypesAction
  extends IAsyncFetchableAction<typeof SERVICE_PERFORMANCE_LOAD_SERVICE_TYPES_INT> {}

export interface ILoadServiceTypesSuccessAction
  extends IAsyncAction<typeof SERVICE_PERFORMANCE_LOAD_SERVICE_TYPES_INT> {
  data: IServiceTypesResponseInt
}

export type LoadServiceTypesErrorAction = IAsyncErrorAction<
  typeof SERVICE_PERFORMANCE_LOAD_SERVICE_TYPES_INT
>

export const loadServiceTypesStartInt = (): ILoadServiceTypesAction => ({
  status: AsyncActionState.Initiated,
  type: SERVICE_PERFORMANCE_LOAD_SERVICE_TYPES_INT,
  isFetchable: true,
})

export const loadServiceTypesSuccessInt = (
  data: IServiceTypesResponseInt,
): ILoadServiceTypesSuccessAction => ({
  status: AsyncActionState.Success,
  type: SERVICE_PERFORMANCE_LOAD_SERVICE_TYPES_INT,
  data,
})

export const loadServiceTypesErrorInt = (error: string): LoadServiceTypesErrorAction => ({
  status: AsyncActionState.Failure,
  type: SERVICE_PERFORMANCE_LOAD_SERVICE_TYPES_INT,
  error,
})
